import { createSlice } from "@reduxjs/toolkit";

export const SOCIAL_SECURITY_SLICE = "socialSecurity"
const socialSecuritySlice = createSlice({
    name: "socialSecurity",
    initialState: {
        isLoading: false,
        isLogin: false,
        hospital: [],
        nationality: [],
        socialSecurityNo: [],
        registrationDocument: [],
        reasonForSsoDocument: [],
    },
    reducers: {
        setIsLoading(state, action) {
            state.isLoading = action.payload;
        },
        setHospital(state, action) {
            state.hospital = action.payload;
        },
        setNationality(state, action) {
            state.nationality = action.payload;
        },
        setSocialSecurityNo(state, action) {
            state.socialSecurityNo = action.payload;
        },
        setRegistrationDocument(state, action) {
            state.registrationDocument = action.payload;
        },
        setReasonForSsoDocument(state, action) {
            state.reasonForSsoDocument = action.payload;
        },

    },
});

export const {
    setIsLoading,
    setHospital,
    setNationality,
    setSocialSecurityNo,
    setRegistrationDocument,
    setReasonForSsoDocument,

} = socialSecuritySlice.actions;
export default socialSecuritySlice.reducer;
